import { AxiosResponse } from "axios";
import BaseDAO from "../BaseDAO";

class SearchBaseDAO extends BaseDAO {
  protected basePath: string =
    "https://8ba5bab851d64a2db0e0cf8ab39ba8ce.ent-search.eastus2.azure.elastic-cloud.com/";

  protected getBasePath(): string {
    return this.basePath;
  }

  private config: any = {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer private-tv2ci4h18w9rgxei9xfxaaoc",
    },
    crossDomain: true,
  };

  public get(key: string, url: string): Promise<AxiosResponse<any>> {
    return super.get(key, url, this.config);
  }

  public post(url: string, body: any): Promise<AxiosResponse<any>> {
    return super.post(url, body, this.config);
  }

  public patch(url: string, body: any): Promise<AxiosResponse<any>> {
    return super.patch(url, body, this.config);
  }

  public delete(url: string, body: any): Promise<AxiosResponse<any>> {
    return super.delete(url, body, this.config);
  }
}

export default SearchBaseDAO;
